import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { SensorsList } from 'components/Sensors/SensorsList';
import MDBox from 'components/MDBox';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardLayout from 'layouts/LayoutContainers/DashboardLayout';
import useCustomBackButtonHandler from '../../hooks/useCustomBackButtonHandler';
import SignIn from '../authentication/sign-in';
import PdfDocument from './components/PdfDocument/PdfDocument';

export const SensorsListPage = () => {
  const dispatch = useDispatch();

  // Keep PDF logic, remove token/user logic
  const pdfName = useSelector(state => state.persistence.pdfFile);
  const setPdfName = pdf => dispatch(setPdf({ pdfFile: pdf }));

  useCustomBackButtonHandler(() => setPdfName(''));

  const pdfFile = pdfName; // ✅ Simple rename for clarity

  return (
    <DashboardLayout>
      <DashboardNavbar objectName="Sensors list" />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox pt={{ xs: 1 }} pb={1}>
        {!pdfFile ? (
          <Grid container>
            <Grid item xs={12}>
              <SensorsList setPdfName={setPdfName} />
            </Grid>
          </Grid>
        ) : (
          <PdfDocument file={pdfFile} handleClose={() => setPdfName('')} />
        )}
      </MDBox>
    </DashboardLayout>
  );
};
